export { default as GiftingCategoryPage } from "./View";